// extracted by mini-css-extract-plugin
export var clickThrough = "_xa-2";
export var fallback = "_xa-5";
export var frame = "_xa-3";
export var frameCell = "_xa-1";
export var overlay = "_xa-4";
export var wrapper = "_xa-0";